import axios from 'axios';

export const fetchVisitSkuValidations = (projectId, visitId) => axios.get(`/projects/${projectId}/visit_sku_validations/${visitId}`);
export const saveSkuValidation = (projectId, visitId, skuValidationId, body) => axios.put(`/projects/${projectId}/visits/${visitId}/sku_validations/${skuValidationId}`, body);
export const createSkuValidation = (projectId, visitId) => axios.post(`/projects/${projectId}/visits/${visitId}/sku_validations`, { sku_validation: { body: [] } });
export const fetchSkuValidations = (projectId, visitId, skuValidationId) => axios.get(`/projects/${projectId}/visits/${visitId}/sku_validations/${skuValidationId}`);
export const fetchNonSkuClasses = (projectId, params = {}) => axios.get(`/projects/${projectId}/non_sku_classes`, { params });

export default {
  saveSkuValidation,
  fetchVisitSkuValidations,
  fetchSkuValidations,
  fetchNonSkuClasses
};
